
var backButton = '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="9" height="18" fill="none" viewBox="0 0 14 22"><path stroke="#d1ba98" stroke-linecap="round" stroke-linejoin="round" stroke-width="4" d="M11.5 20l-9-9 9-9"></path></svg></button>';
var nextButton = '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="9" height="18" fill="none" viewBox="0 0 14 22" class="Right__StyledSvg-sc-17n0xjn-0 hiRFYo"><path  stroke="#d1ba98" stroke-linecap="round" stroke-linejoin="round" stroke-width="4" d="M2.5 20l9-9-9-9"></path></svg></button>'

$('.colletion-custom-slider').slick({
  dots: true,
  infinite: false,
  autoplay: false,
  arrows: true,
  cssEase: 'ease',
  prevArrow: backButton,
  nextArrow: nextButton,
  speed: 300,
  slidesToShow: 1.2,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1.1,
        slidesToScroll: 1,
        arrows: false,
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1.1,
        slidesToScroll: 1,
        arrows: false,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1.1,
        slidesToScroll: 1,
        arrows: false,
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});


// Tab section Start 
 $(document).ready(function(){
 
// Tab section Start 
    // Show the first tab and hide the rest
$('#tabs-nav li:first-child').addClass('active');
$('.tab__imags_container .tab_content_cust:first-child').addClass('active');
    
// Click function
$('#tabs-nav li').click(function(){
  $('#tabs-nav li').removeClass('active');
  $(this).addClass('active');
  
let tabID = $(this).find(".tab_button_txt").attr('data-tab');
$(`#img-tab-${tabID}`).addClass('active').siblings().removeClass('active');
  
  var activeTab = $(this).find('a').attr('href');
  $(activeTab).fadeIn();
  return false;
});
// Tab section End 
});

function ensureBoldPaymentButtonTarget() {
  document.querySelectorAll('form[action*="/cart/add"], .product-single__form').forEach(function (form) {
    if (form.querySelector('.shopify-payment-button__button')) return;

    var dummy = document.createElement('button');
    dummy.type = 'button';
    dummy.className = 'shopify-payment-button__button bold_hidden';
    dummy.hidden = true;
    dummy.setAttribute('aria-hidden', 'true');
    dummy.tabIndex = -1;
    form.appendChild(dummy);
  });
}

ensureBoldPaymentButtonTarget();

function syncBoldRadioActive(group) {
  var groups = group ? [group] : document.querySelectorAll('.bold_option_radio');
  groups.forEach(function (optionGroup) {
    optionGroup.querySelectorAll('.bold_option_value_element').forEach(function (element) {
      var radio = element.querySelector('input[type="radio"]');
      element.classList.toggle('active', !!(radio && radio.checked));
    });
  });
}

function bindBoldRadioOptions() {
  var radios = document.querySelectorAll('.bold_option_radio input[type="radio"]');
  if (!radios.length) return false;

  radios.forEach(function (input) {
    if (input.dataset.boldRadioBound) return;
    input.dataset.boldRadioBound = 'true';
    input.addEventListener('change', function () {
      syncBoldRadioActive(input.closest('.bold_option_radio'));
    });
  });

  syncBoldRadioActive();
  return true;
}

function initBoldRadioOptions() {
  if (bindBoldRadioOptions()) return;

  var root = document.querySelector('.bold_options');
  if (!root) return;

  var observer = new MutationObserver(function () {
    if (bindBoldRadioOptions()) observer.disconnect();
  });
  observer.observe(root, { childList: true, subtree: true });
  setTimeout(function () {
    observer.disconnect();
    bindBoldRadioOptions();
  }, 15000);
}

document.addEventListener('change', function (event) {
  var input = event.target;
  if (!input.matches || !input.matches('.bold_option_radio input[type="radio"]')) return;
  syncBoldRadioActive(input.closest('.bold_option_radio'));
});

document.addEventListener('click', function (event) {
  var label = event.target.closest('.bold_option_radio label');
  if (!label) return;

  var input = label.querySelector('input[type="radio"]');
  if (!input || input.disabled) return;

  if (!input.checked) {
    input.checked = true;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
  syncBoldRadioActive(label.closest('.bold_option_radio'));
});

document.addEventListener("DOMContentLoaded", (event) => {
  initBoldRadioOptions();

  setTimeout(function(){
    let dropDownDrop = document.querySelectorAll('.bold_option.bold_option_dropdown');
    dropDownDrop?.forEach((dropDown) => {
      let queryElement = dropDown.querySelector('.bold_help_text');
      let optionLabel = dropDown.querySelector('label');
      let referranceElement = dropDown.querySelector('label .bold_option_element');
      let helpWrapper = dropDown.querySelector('.help-wrapper');
      // console.log(helpWrapper)

      if (queryElement && optionLabel && referranceElement && helpWrapper) {
        dropDown.querySelector('.bold_option_title').classList.add('element-width');
        queryElement.classList.add('element-position');
        optionLabel.insertBefore(queryElement, referranceElement);
        console.log("Moved .bold_help_text as second child of optionLabel");
      } else {
        console.log(".bold_help_text or optionLabel not found in dropdown");
      }
      
    });
  }, 5000);
});



